module.exports = __webpack_public_path__ + "static/media/home-contracting-2.fff64aed.jpg";